import React from 'react';

import { Helmet } from 'react-helmet';
import { Global, css } from '@emotion/react';

const fonts = [
  ['Graphik-Bold-Cy-Web', 'woff2', 'Graphik', 700],
  ['Graphik-Light-Cy-Web', 'woff2', 'Graphik', 300],
  ['Graphik-Medium-Cy-Web', 'woff2', 'Graphik', 500],
  ['Graphik-Regular-Cy-Web', 'woff2', 'Graphik', 400],
];

const fontUrlBase = 'https://cdn-cashy-static-assets.lucidchart.com/fonts/graphik/';

// loop through fonts and build the CSS to declare each one.
const declareFontsCss = fonts.reduce((string, [name, type, family, weight]) => {
  return `${string}
  @font-face {
    font-family: '${family}';
    src: url('${fontUrlBase}${name}.${type}') format('${type}');
    font-weight: ${weight};
    font-display: auto;
  }`;
}, '');

const FontLoader = () => (
  <>
    <Global styles={css(declareFontsCss)} />
    <Helmet>
      {fonts.map(([name, type]) => (
        <link
          key={name}
          as="font"
          crossOrigin="anonymous"
          href={`${fontUrlBase}${name}.${type}`}
          rel="preload"
          type={`font/${type}`}
        />
      ))}
    </Helmet>
  </>
);

export { FontLoader };
export default FontLoader;
